import { collection, Timestamp, setDoc, doc, Firestore } from "firebase/firestore";
import { v4 as uuidv4 } from 'uuid';

export const createJob = async (firestore: Firestore, jobDetails: any): Promise<any> => {
    const jobsCollection = collection(firestore, 'jobs');
    const newId = uuidv4();
    const timestamp = Timestamp.fromDate(new Date());

    const data = {
        id: newId,
        status: 'new',
        ...jobDetails,
        createdAt: timestamp,
        updatedAt: timestamp,
    }

    const job = await setDoc(doc(jobsCollection, newId), data, { merge: true });
    return newId;
}